export enum ElectricityMeterKind {
    Electronic = "Electronic",
    Linky = "Linky",
    Mechanical = "Mechanical",
}
